import type { CrudArgs } from "./composables/ContextVoter";
import { PermissionScope } from "@verbleif/lib/src/composables/Api/Type/UserPermissions/userPermission.enum";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class ProductInventoryVoter extends ContextVoter {
  public canReadHistory(item: CrudArgs = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }): boolean {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationProductInventoryReadhistoryany,
      contextAttribute: PermissionAttributesEnum.ContextOperationProductInventoryReadHistory,
      scope: PermissionScope.PROPERTY,
    });
  }

  public canAdjust(item: CrudArgs = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }): boolean {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationProductInventoryAdjustany,
      contextAttribute: PermissionAttributesEnum.ContextOperationProductInventoryAdjust,
      scope: PermissionScope.PROPERTY,
    });
  }

  public canToggleTracking(item: CrudArgs = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }): boolean {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationProductInventoryToggletrackingany,
      contextAttribute: PermissionAttributesEnum.ContextOperationProductInventoryToggleTracking,
      scope: PermissionScope.PROPERTY,
    });
  }
}
